import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Typography, Container, Grid, IconButton } from "@mui/material";
import { uploadSelector, updateFolder } from "../store/slices/upload";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { getFolderFullName } from './../common/utils'
import CloseIcon from '@mui/icons-material/Close'

const byteArrayToBase64 = (byteArray) => {
  return btoa(
    byteArray.reduce((data, byte) => data + String.fromCharCode(byte), "")
  );
};

export default function AlertDialog({ toggle, open }) {
  //const [bytearr, setBytearr] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [fileData, setFileData] = React.useState([]);
  const dropRef = React.useRef();
  const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const files = event.target.files;
    const byteArrays = [];

    // Iterate over the selected files
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();
      reader.onloadend = (e) => {
        // Convert the result into a byte array (ArrayBuffer)
        const byteArray = new Uint8Array(e.target.result);
        const obj = {
          fileName: file.name,
          fileType: file.type,
          content: null, // Reserved for future use.
          contentBase64: byteArrayToBase64(byteArray), // Base64 encoding of file content.
          folderName: getFolderFullName(file.webkitRelativePath, file.name)
        };
        byteArrays.push(obj);

        // Store the byte arrays to the state
        setFileData(prev => [...prev, obj]);
      };

      reader.readAsArrayBuffer(file); // Read the file as an ArrayBuffer
    }
  };
  const generateBase64Images = () => {
    if (fileData.length > 0) {
      dispatch(
        updateFolder({
          requestProfileId: localStorage.getItem("userId"),
          files: fileData,
        })
      );
      toggle();
      setFileData([]);
      setError([]);
    }
    else {
      setError("Files not selected.");
    }
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.items) {
      const items = e.dataTransfer.items;
      const fileEntries = [];
      const byteArrays = [];
      const traverseFileTree = (item, path = '') => {
        if (item.isFile) {
          item.file((file) => {
            file.relativePath = path + file.name;
            fileEntries.push(file);
            //setFileData(prev => [...prev, file]);
            //const file = files[i];
            const reader = new FileReader();
            reader.onloadend = (e) => {
              // Convert the result into a byte array (ArrayBuffer)
              const byteArray = new Uint8Array(e.target.result);
              const obj = {
                fileName: file.name,
                fileType: file.type,
                content: null, // Reserved for future use.
                contentBase64: byteArrayToBase64(byteArray), // Base64 encoding of file content.
                folderName: getFolderFullName(file.relativePath, file.name)
              };
              byteArrays.push(obj);

              // Store the byte arrays to the state
              setFileData(prev => [...prev, obj]);
            };

            reader.readAsArrayBuffer(file); // Read the file as an ArrayBuffer
          });
        } else if (item.isDirectory) {
          const dirReader = item.createReader();
          dirReader.readEntries((entries) => {
            entries.forEach((entry) => traverseFileTree(entry, path + item.name + '/'));
          });
        }
      };

      for (let i = 0; i < items.length; i++) {
        const item = items[i].webkitGetAsEntry();
        if (item) {
          traverseFileTree(item);
        }
      }
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  return (
    <div>
      <Dialog
        open={open}
        onClose={toggle}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h5">{"Upload Folder"}</Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '10px !important' }}>
          <Container maxWidth="md" >
            <div>
              <form >
                <div className="picker" for="selectFolder">
                  <div
                    ref={dropRef}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    style={{
                      //border: '2px dashed #aaa',
                      borderRadius: '5px',
                      //padding: '30px',
                      textAlign: 'center',
                      color: '#4f4f4f',
                      padding: '10vh',
                      fontFamily: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol'
                    }}
                  >
                    Drag and Drop your folder or<label for="selectFolder" className="custom-file-upload" id="choose-file-label">
                      <span style={{
                        cursor: 'pointer'
                      }}><u>Browse</u></span>
                    </label>
                  </div>
                  <input
                    name="uploadDocument"
                    id="selectFolder"
                    type="file"
                    webkitdirectory="true"
                    directory="true"
                    onChange={handleFileChange}
                    multiple
                    style={{ display: 'none' }}

                  />
                  {/* <h3>Selected Folders:</h3> */}
                  {fileData.length > 0 && <Grid container spacing={2} sx={{marginTop:"10px"}}>
                    {_.uniqBy(fileData, 'folderName').map((file, index) => (
                      <Grid item xs={4} md={4} lg={4} xl={4} wide={4}><span>&#9679;</span>{file.folderName}
                        <IconButton
                          onClick={(event) => {
                            setFileData(_.filter(fileData, item => { return !item.folderName == file.folderName }))
                          }}
                          sx={{
                            height: '10px',
                            //borderColor: '#007bff',
                            color: '#727272',
                            //border: '1px solid #007bff',
                            //borderRadius: "20%",
                            fontSize: '1.0286rem',
                            backgroundColor: '#eee',
                            width: '10px',
                            marginLeft: '10px',
                            ':hover': {
                              //bgcolor: '#F6F6F7',
                              //borderColor: '#007bff',
                              color: '#007bff',
                              backgroundColor: '#eee',
                            }
                          }}
                          variant='outlined' color='secondary'><CloseIcon sx={{ fontSize: '1.4142857142857142rem' }} /></IconButton>
                      </Grid>
                    ))}
                  </Grid>}
                </div>
              </form>
              <div>

              </div>
            </div>
          </Container>
          {error && <Typography color={'red'} ml={3}>{error}</Typography>}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={generateBase64Images}>
            Save
          </Button>
          <Button variant="text" onClick={() => { toggle(); setFileData([]); setError([]); }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
